export default __webpack_public_path__ + "static/npf-logo-144-47acc56cef182d087532a5ca5ff1428f.png";